import React from 'react';
import UiLogin from './uiLogin.js';
import UiIntro from './uiIntro';
import UiSettings from './uiSettings'
import UiHeader from './uiHeader';
import UiFooter from './uiFooter';
import UiHome from './uiHome';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { PrivateRoute } from "../helper/routes";
import UiGenerateDashboard from './uiGenerateDashboard';
import UiAddField from './uiAddField';
import ChsUiDevice from './chirpstack/chsUiDevice.js';
import '../assets/style.scss'
import PageTitle from '../components/pageTitle.js';
import UiAddDevice from './uiAddDevice.js';
import UiDeviceHistory from './uiDeviceHistory'
import UiAddCustomer from './uiAddCustomer';
import UiAssignDashboard from './uiAssignDashboard';
import UiAssignField from './uiAssignField';
import DocAcuadori from '../docs/doc_acuadori'
import UiAddDeviceMeteo from './uiAddDeviceMeteo.js';

class UiMainApp extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            bg: 'light'
        }
    }

    logout = () => {
        this.props.services.thingsboard.login.logout();
        this.props.services.chirpstack.login.logout();
    }

    getExternalLinks = () => {
        let thb = this.props.services.thingsboard.routes();
        let chs = this.props.services.chirpstack.routes();

        return {
            thingsboardRoutes: { Home: thb.home, Dashboard: thb.dashboards, Fields: thb.assets, Devices: thb.devices },
            chirpstackRoutes: { Home: chs.home }
        }
    }

    render() {
        let _isAuthenticated = this.props.coreState.thingsboard.loggedIn && this.props.coreState.chirpstack.loggedIn;
        return (
            <Router>
                <div>
                    {
                        <Switch>
                            <Route exact path='/' render={() => null}></Route>
                            <Route path='/'>
                                <UiHeader logout={this.logout} isAuthenticated={_isAuthenticated} bg={this.state.bg} />
                            </Route>
                        </Switch>
                    }
                    <main>
                        <Switch>
                            <PrivateRoute path="/home" isAuthenticated={_isAuthenticated}>
                                <PageTitle title='Acuadori' subTitle='Home' />
                                <UiHome nextRoute='/home'
                                    links={this.getExternalLinks()} />
                            </PrivateRoute>
                            <PrivateRoute path="/addCustomer" isAuthenticated={_isAuthenticated}>
                                <PageTitle title='New Customer' subTitle='Thingsboard' />
                                <UiAddCustomer
                                    title='New Customer' subTitle='Thingsboard'
                                    links={this.getExternalLinks()}
                                    nextRoute='/home'
                                    services={{
                                        customer: this.props.services.thingsboard.customer,
                                        user: this.props.services.thingsboard.user,
                                        dashboard: this.props.services.thingsboard.dashboard
                                    }}
                                ></UiAddCustomer>
                            </PrivateRoute>


                            <PrivateRoute path="/assignDashboard" isAuthenticated={_isAuthenticated}>
                                <PageTitle title='Assign Dashboard' subTitle='Thingsboard' />
                                <UiAssignDashboard nextRoute='/home'
                                    links={this.getExternalLinks()}
                                    services={{
                                        customer: this.props.services.thingsboard.customer,
                                        device: this.props.services.thingsboard.device,
                                        asset: this.props.services.thingsboard.asset,
                                        dashboard: this.props.services.thingsboard.dashboard
                                    }} />
                            </PrivateRoute>
                            <PrivateRoute path="/generateDashboard" isAuthenticated={_isAuthenticated}>
                                <PageTitle title='New Dashboard' subTitle='Thingsboard' />
                                <UiGenerateDashboard nextRoute='/home'
                                    links={this.getExternalLinks()}
                                    services={{
                                        customer: this.props.services.thingsboard.customer,
                                        device: this.props.services.thingsboard.device,
                                        asset: this.props.services.thingsboard.asset,
                                        dashboard: this.props.services.thingsboard.dashboard
                                    }} />
                            </PrivateRoute>
                            <PrivateRoute path="/addField" isAuthenticated={_isAuthenticated}>
                                <PageTitle title='New Field' subTitle='Thingsboard' />
                                <UiAddField subTitle='Thingsboard'
                                    nextRoute='/home'
                                    links={this.getExternalLinks()}
                                    services={{
                                        customer: this.props.services.thingsboard.customer,
                                        asset: this.props.services.thingsboard.asset
                                    }} />
                            </PrivateRoute>
                            <PrivateRoute path="/assignField" isAuthenticated={_isAuthenticated}>
                                <PageTitle title='Assign Field' subTitle='Thingsboard' />
                                <UiAssignField nextRoute='/home'
                                    links={this.getExternalLinks()}
                                    services={{
                                        customer: this.props.services.thingsboard.customer,
                                        asset: this.props.services.thingsboard.asset
                                    }} />
                            </PrivateRoute>
                            <PrivateRoute path="/addDevice" isAuthenticated={_isAuthenticated}>
                                <PageTitle title='New Device' subTitle='Thingsboard' />
                                <UiAddDevice nextRoute='/home'
                                    title="New Device"
                                    links={this.getExternalLinks()}
                                    services={{
                                        customer: this.props.services.thingsboard.customer,
                                        device: this.props.services.thingsboard.device,
                                    }} />
                            </PrivateRoute>
                            <PrivateRoute path="/addDeviceMeteo" isAuthenticated={_isAuthenticated}>
                                <PageTitle title='New Device Meteo' subTitle='Thingsboard' />
                                <UiAddDeviceMeteo nextRoute='/home'
                                    title="New Device Meteo"
                                    links={this.getExternalLinks()}
                                    services={{
                                        customer: this.props.services.thingsboard.customer,
                                        device: this.props.services.thingsboard.device,
                                    }} />
                            </PrivateRoute>
                            <PrivateRoute path="/deviceHistory" isAuthenticated={_isAuthenticated}>
                                <PageTitle title='Get Device Telemetry History' subTitle='Thingsboard' />
                                <UiDeviceHistory nextRoute='/home'
                                    links={this.getExternalLinks()}
                                    services={{
                                        device: this.props.services.thingsboard.device,
                                    }} />
                            </PrivateRoute>
                            <Route path="/login">
                                <PageTitle title='Login' subTitle={UiSettings.Login.labels.site} />
                                <UiLogin {...UiSettings.Login}
                                    nextRoute='/loginLoraWan'
                                    services={this.props.services.thingsboard.login}
                                    loggedIn={this.props.coreState.thingsboard.loggedIn} />
                            </Route>
                            <PrivateRoute path="/loginLoraWan" isAuthenticated={this.props.coreState.thingsboard.loggedIn}>
                                <PageTitle title='Login' subTitle={UiSettings.ChirpstackLogin.labels.site} />
                                <UiLogin {...UiSettings.ChirpstackLogin}
                                    nextRoute='/home'
                                    services={this.props.services.chirpstack.login}
                                    loggedIn={this.props.coreState.chirpstack.loggedIn} />
                            </PrivateRoute>
                            <PrivateRoute path="/loraWanDevice" isAuthenticated={_isAuthenticated}>
                                <PageTitle title='New LoraWan Device' subTitle='with Thingsboard connection' />
                                <ChsUiDevice title='New LoraWan Device' nextRoute='/home' services={{
                                    device: this.props.services.chirpstack.device,
                                    thingsboardDevice: this.props.services.thingsboard.device
                                }} />
                            </PrivateRoute>

                            {/*************** Documentation ***********************************************/}
                            <PrivateRoute exact path="/docs" isAuthenticated={_isAuthenticated}>
                                <PageTitle title='Acuadori' subTitle='Documentation' />
                                <DocAcuadori isAuthenticated={_isAuthenticated} />
                            </PrivateRoute>
                            <PrivateRoute path="/docs/:path" isAuthenticated={_isAuthenticated}>
                                <PageTitle title='Acuadori' subTitle='Documentation' />
                                <DocAcuadori isAuthenticated={_isAuthenticated} />
                            </PrivateRoute>
                            {/** END ********** Documentation ********************************************/}

                            <Route path="/">
                                <UiIntro {...UiSettings.Intro} nextRoute="/login" bg={this.state.bg} />
                            </Route>

                        </Switch>
                    </main>
                    <div className="mb-4">
                        <UiFooter bg={this.state.bg} />
                    </div>
                </div>
            </Router>
        );
    };
}

export default UiMainApp;
